import { useParams } from "react-router-dom";
import { getApiUrl } from "../../app-config";
import { useRequest } from "../../hooks/useRequest";
import { HeadLine } from "../../layouts/headers/HeadLine";
import { DetailDocumentView } from "./views/DetailDocumentView";
import { DetailListView } from "./views/DetailListView";

export const InformationDetail = () => {


    const params = useParams();
    const dataSection = useRequest(getApiUrl(`Information/${params.InfoDetailId}`));
    const dataDetails = useRequest(getApiUrl(`InformationDetail?informationId=${params.InfoDetailId}&languageKey=es`));

    if (dataSection.error) {
        return (
            <div className='w-full absolute z-1 head-hi-sm flex flex-col justify-center'>
                <HeadLine title={'No encontrado, intenta mas tarde'} backurl='/hotel-info' />
            </div>
        );
    }


    if (!dataSection.data && !dataDetails.data) {
        return (<h1>Cargando...</h1>)
    }

    return (
        <div>
            <div className='w-full absolute z-1 head-hi-sm flex flex-col justify-center'>
                <HeadLine title={dataSection?.data?.title} backurl='/hotel-info' />
            </div>

            <div className="w-full relative content-hi-sm">
                <DetailDocumentView content={dataSection.data} />

                <div className="line mt-12 mb-12"></div>

                {
                    !dataDetails.loading && (<DetailListView list={dataDetails.data} />)
                }
            </div>

        </div>
    );
};
